import axios from 'axios';
import { genericRoute } from '../../routes';

import { USERS_LOGIN_FB, RECV_ERROR } from '../../constants/actions';
import { dispatchError } from '../../actions/errors';

window.fbAsyncInit = function() {
	//console.log('fb init');
	window.FB.init({
		appId: window.konfig.social.fbAppId,
		cookie: true,
		xfbml: true,
		version: 'v2.5',
	});
};

export default class FBAuth {
	constructor() {
		//this.load();
	}

	load() {
		if (!this.isLoaded()) {
			// Inject facebook api
			(function(d, s, id) {
				var js, fjs = d.getElementsByTagName(s)[0];
				if (d.getElementById(id)) return;
				js = d.createElement(s); js.id = id;
				js.src = 'https://connect.facebook.net/en_GB/sdk.js';
				fjs.parentNode.insertBefore(js, fjs);
			}(document, 'script', 'facebook-jssdk'));
		}
	}

	isLoaded() {
		return (typeof this.API === 'object');
	}

	share(url) {
		if (this.isLoaded()) {
			this.API.ui({
				method: 'share',
				href: url,
			}, function(response){
				//console.log(response);
			});
		} else {
			this.load();
		}
	}

	get API() {
		return window.FB;
	}

	login(dispatch) {
		return this._FBLogin(genericRoute(false, 'api/account/facebooksignin'), dispatch);
	};

	register(dispatch) {
		return this._FBLogin(genericRoute(false, 'api/account/facebooksignup'), dispatch);
	};

	_FBLogin(path, dispatch) {
		if (this.isLoaded()) {
			this.API.login(function(fbRes) {
				if (fbRes.authResponse) {
					// var date = new Date();
					// date.setTime(date.getTime() + (31 * 24 * 60 * 60 * 1000));
					// let cookie = 'fb_access_token=' + fbRes.authResponse.accessToken + '; expires=' + date.toGMTString();
					// document.cookie = cookie;
					axios.post(path)
					.then((res) => {
						//console.log('Signed in as: ' + res.data.user.name);
						if (res.data.user) {
							dispatch({
								type: USERS_LOGIN_FB,
								payload: res.data,
							});
						}
					})
					.catch((res) => {
						dispatch(dispatchError(res.data));
					});
				} else {
					dispatch(dispatchError({
						message: 'Facebook Auth not completed.'
					}));
				}
			}, { scope: 'email' });
		} else {
			this.load();
		}
	}
};



/** WEBPACK FOOTER **
 ** ./frontend/utils/social/fb.js
 **/